import * as React from 'react';

//Material
import { Accordion, AccordionDetails, Grid, styled, Typography } from '@mui/material';
//Components
import { StyledTitle } from '../../../components/StyledComponents';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
// import expandIcon from '../../../assets/arrowExpand.png'
// import testPic from '../../../assets/testServices/testService1.png'

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    transform: 'rotate(270deg)'
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1)
  }
}));
export default function BottomBlock() {
  const [expanded, setExpanded] = React.useState('');

  // useEffect(() => {
  //   const element = document.getElementById('questionsBlock');
  // }, []);
  // useEffect(() => {
  //   if (window.screen.width <= 900) {
  //     setScreenType('mobile');
  //   }
  // }, []);
  const text = [
    {
      title: 'Хто може користуватися платформою?',
      description:
        'Наша платформа створена для виробників, фермерів, ремісників, стартапів, підприємців тощо, які хочуть розширити свій бізнес, а також для покупців, які шукають унікальні та якісні товари.'
    },
    {
      title: 'Як почати продавати?',
      description: (
        <ol
          style={{
            fontFamily: 'FixelText-Regular !important',
            paddingLeft: '0px',
            listStyleType: 'none'
          }}
        >
          <li>1. Зареєструйтеся на платформі.</li>
          <li>2. Створіть сторінку свого бренду.</li>
          <li>3 .Додайте товар.</li>
          <li>4. Почніть отримувати замовлення.</li>
          <br />

          <p style={{ marginTop: '0px' }}>
            Щоб отримати більше можливостей, скористайтеся{' '}
            <a
              rel="noreferrer"
              href={`${window.location.protocol}//${window.location.hostname}/ua/tariffs`}
              style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}
            >
              преміум-підпискою
            </a>
            .
          </p>
        </ol>
      )
    },
    {
      title: 'Що таке преміум-підписка і які її переваги?',
      description: (
        <ul
          style={{
            fontFamily: 'FixelText-Regular !important',
            listStyleType: 'none',
            paddingLeft: '0px'
          }}
        >
          <p style={{ marginTop: '0px' }}>Преміум відкриває розширені можливості для продавців:</p>
          <li>✔️ Необмежена кількість товарів для створення</li>
          <li>✔️ Календар замовлень</li>
          <li>✔️ Просування акаунту та товарів</li>
          <li>✔️ Аналітика та звітність</li>
          <br />
          <p style={{ marginTop: '0px' }}>
            Ознайомитися з тарифами можна на{' '}
            <a
              rel="noreferrer"
              href={`${window.location.protocol}//${window.location.hostname}/ua/tariffs`}
              style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}
            >
              сторінці тарифів
            </a>
            .
          </p>
        </ul>
      )
    },
    {
      title: 'Як купити преміум-тариф і коли він активується?',
      description: (
        <ol
          style={{
            fontFamily: 'FixelText-Regular !important',
            listStyleType: 'none',
            paddingLeft: '0px'
          }}
        >
          <li>1. Зареєструйтесь на платформі.</li>
          <li>2. Перейдіть на сторінку тарифів та оберіть потрібний план.</li>
          <li>3. Виконайте оплату через Monopay.</li>
          <li>4. Підписка активується миттєво після підтвердження платежу.</li>
          <br />
          <p style={{ marginTop: '0px' }}>
            Підтвердження про активацію буде надіслано на ваш email. Детальна інформація про покупку
            доступна в{' '}
            <a
              rel="noreferrer"
              href={`${window.location.protocol}//${window.location.hostname}/ua/agreement?pr=p11`}
              style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}
            >
              користувальницькій угоді
            </a>
            , пункт 11.
          </p>
        </ol>
      )
    },
    {
      title: 'Які способи оплати доступні?',
      description:
        'Ми підтримуємо оплату банківськими картами (Visa, MasterCard) через Monopay. Оплату можна здійснити через сервіс Monopay під час оформлення підписки.'
    },
    {
      title: 'Чи можна скасувати підписку або отримати повернення?',
      description: (
        <p style={{ marginTop: '0px' }}>
          Так, ви можете скасувати підписку в будь-який момент. Однак кошти за використаний період
          не повертаються. <br />
          Якщо виникли технічні проблеми або кошти були стягнуті помилково, зверніться в{' '}
          <a
            rel="noreferrer"
            href={`${window.location.protocol}//${window.location.hostname}/ua/support`}
            style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}
          >
            службу підтримки
          </a>
          . Більше деталей про повернення – в{' '}
          <a
            rel="noreferrer"
            href={`${window.location.protocol}//${window.location.hostname}/ua/agreement?pr=p12`}
            style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}
          >
            користувальницькій угоді, пункт 12.
          </a>
        </p>
      )
    }
  ];
  // const style = {
  //   width: '100%',
  //   borderTop: 'none !important',
  //   borderRadius: '8px !important',
  //   '&.MuiAccordion-root .Mui-expanded .MuiAccordion-heading': {
  //     backgroundColor: '#F5F4F4'
  //   }
  // };

  const handleChange = (panel) => {
    if (panel !== expanded) {
      setExpanded(panel);
    } else setExpanded('');
  };
  return (
    <Grid item xs={12} sx={{ mt: 1, mb: 5 }}>
      <StyledTitle variant="h2" className="bottomBlock-title">
        Поширені запитання
      </StyledTitle>

      {/* <Divider variant="fullWidth" style={{border:'1px solid #60A5DF'}} component="li" /> */}
      {text.map((el, index) => (
        <React.Fragment key={index}>
          <Accordion
            sx={{ borderRadius: '8px', boxShadow: 'none' }}
            expanded={expanded === `panel${index}`}
            onChange={() => handleChange(`panel${index}`)}
          >
            {/* <AccordionSummary   expandIcon={expanded === `panel${index}`&&<img  alt='arrow'src={expandIcon}   />}> */}
            <AccordionSummary>
              <Typography
                id={`helpTitle-${index}`}
                component="span"
                sx={{
                  fontSize: { xs: '16px', sm: '24px' },
                  fontFamily: 'FixelText-Medium !important',

                  cursor: 'pointer'
                }}
              >
                {el.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                id={`helpDesc-${index}`}
                component="p"
                sx={{
                  fontSize: { xs: '16px', sm: '20px' },
                  // maxWidth: '90%',
                  fontFamily: 'FixelText-Regular !important',
                  mb: 1,
                  ml: '20px'
                }}
              >
                {el.description}
              </Typography>
              {/* <img
                src={testPic}
                alt='test'
                style={expanded === `panel${index}`?{ width: '250px', height: '250px', position:'absolute', top:'-5px', right:'10%', transform:'rotate(15deg)', transition: 'right 1s ease 0s', zIndex:'999' }:{ width: '250px', height: '250px', position:'absolute', top:'-5px', right:'-30%', transform:'rotate(15deg)',transition: 'right 0.5s ease 0s', zIndex:'999' }}
              /> */}
            </AccordionDetails>
          </Accordion>
          {/* <Divider variant="fullWidth" component="li" style={{border:'1px solid #60A5DF'}}/> */}
        </React.Fragment>
      ))}
    </Grid>
  );
}
